import { StyleProp, ViewStyle } from 'react-native';
import Svg, { Circle, Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

function SellHigherRaw({
  style,
  width,
}: {
  style?: StyleProp<ViewStyle>;
  className: string;
  width?: number;
}) {
  return (
    <Svg
      width={width ?? 22}
      height={width ?? 22}
      viewBox="0 0 22 22"
      fill="none"
      style={style}
    >
      <Circle cx="10.8535" cy="11.1543" r="9.47852" stroke="white" />
      <Circle cx="4.74782" cy="7.38064" r="0.466574" fill="white" />
      <Circle cx="6.31032" cy="7.38064" r="0.466574" fill="white" />
      <Circle cx="7.87282" cy="7.38064" r="0.466574" fill="white" />
      <Circle cx="9.47439" cy="7.38064" r="0.466574" fill="white" />
      <Circle cx="11.0369" cy="7.38064" r="0.466574" fill="white" />
      <Circle cx="12.5994" cy="7.38064" r="0.466574" fill="white" />
      <Circle cx="14.1697" cy="7.38064" r="0.466574" fill="white" />
      <Circle cx="15.7322" cy="7.38064" r="0.466574" fill="white" />
      <Circle cx="17.2947" cy="7.38064" r="0.466574" fill="white" />
      <Path
        d="M9.26562 10.8263L10.8896 9.18993C10.9678 9.1111 11.0953 9.1111 11.1735 9.18993L12.7974 10.8263"
        stroke="white"
        strokeLinecap="round"
      />
      <Path d="M11.0625 9.6875V15.6427" stroke="white" strokeLinecap="round" />
    </Svg>
  );
}

export const SellHigherIcon = nativewindWrapSvg(SellHigherRaw);
